import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tShopModel } from '../Models/tShopModel';
import {AppSettings} from '../shared/AppSettings';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';



@Injectable({
    providedIn: 'root'
  })
  export class tShopService {
  
    constructor(private http: HttpClient) { }
  
    baseurl: string = AppSettings.BaseURI;
  
    readonly pathName = '/Shop';
  
    getAllData(){
      return this.http.get<tShopModel[]>(this.baseurl + this.pathName).pipe(shareReplay(1));
    }
  
    getDataById(id: string){
      return this.http.get<tShopModel>(this.baseurl + this.pathName + '/' + id);
    }
  
    addData(data: tShopModel){
      return this.http.post(this.baseurl + this.pathName, data);
    }
  
    deleteData(data: tShopModel){
      return this.http.delete(this.baseurl + this.pathName + '/' + data.shopID);
    }
  
    updateData(data: tShopModel){
      console.log();
      return this.http.put(this.baseurl + this.pathName + '/' + data.shopID, data);
    }
  }